export const SUPPORTED_CRYPTO_CURRENCIES = [
  'BTC',
  'ETH',
  'USDT',
  'USDC',
  'ADA',
  'LTC',
  'BCH',
  'LINK',
  'DOT',
  'ALGO',
  'EURQ',
];
